import axios from "axios";
import { API } from "configs/api";
import { defaultBody } from "configs/service";

export const adminSignInApi = {
  signIn: (body) => axios.post(API.adminSignIn, { ...body, ...defaultBody }),
  getUserInfo: () => axios.get(API.usersMe, { token: true }),
  updateProfile: (body) => axios.put(API.usersMe, body, { token: true }),
  // formData is this repo's own axios flag (configs/axios.js): without it the
  // request interceptor forces Content-Type: application/json and the file is
  // dropped. It is a POST rather than a PUT because PHP does not populate
  // $_FILES on PUT.
  updateAvatar: (avatar) => {
    const body = new FormData();
    body.append("avatar", avatar);

    return axios.post(API.usersMeAvatar, body, { token: true, formData: true, noCancel: true });
  },
  changePassword: (body) => axios.post(API.usersChangePassword, body, { token: true, noCancel: true }),
  // Daily activity counts for the profile contribution graph. noCancel: the
  // year picker can fire a second request before the first lands, and the
  // interceptor's de-dupe would cancel the one still in flight.
  getMyActivity: (params) => axios.get(API.usersMeActivity, { token: true, params, noCancel: true }),
  getMyActivityDay: (params) => axios.get(API.usersMeActivityDay, { token: true, params, noCancel: true }),
  getNotifications: () => axios.get(API.getNotifications, { token: true }),
  deleteNotification: (id) => axios.delete(`${API.getNotifications}/${id}`, { token: true }),
  readAllNotifications: (body) => axios.put(API.readAllNotifications, body, { token: true }),
};
